const SYMBOL_BY_CODE: Record<string, string> = {
  GBP: '£',
  EUR: '€',
  USD: '$',
  AUD: '$',
  NZD: '$',
  CAD: '$',
};

export const resolveCurrencySymbol = (
  symbol?: string | null,
  code?: string | null,
): string => {
  const iso = (code || '').trim().toUpperCase();
  if (iso && SYMBOL_BY_CODE[iso]) {
    return SYMBOL_BY_CODE[iso];
  }

  const raw = (symbol || '').trim();
  if (raw && !/^[A-Z]{3}$/i.test(raw)) {
    return raw;
  }

  const fromRaw = (raw || 'USD').toUpperCase();
  return SYMBOL_BY_CODE[fromRaw] || raw || '$';
};
